export default {
  QUERY_DOCUMENTS_OVERVIEW: {
    url: '/api/v1/documents/categories',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_DOCUMENTS_LIST: {
    url: '/api/v1/documents',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  SAVE_DOCUMENTS: {
    url: '/api/v1/admin/documents',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  PUT_DOCUMENTS: {
    url: '/api/v1/admin/documents',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  DELETE_DOCUMENTS: {
    url: '/api/v1/admin/documents',
    method: 'delete',
    disableSuccessMsg: false,
    disableErrorMsg: false
  }
}
